export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";